import Row from '@sdk/components/ui/spacing/Row';
import Text14 from '@sdk/components/ui/typography/Text14';
import Tooltip from '@sdk/common/tooltip/Tooltip';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { TimesheetEntry } from '@sdk/timesheets/types/TimesheetEntry';
import { BreakAttestation } from '@sdk/automatedBreaks/types/Attestation';

import { useAutomatedBreaksSummary } from '@web/timeClock/modals/rows/ActualRow/automatedBreaksSummary.hooks';

const TOOLTIP_ID = 'violated-break-tip';

type Props = {
  timesheetEntries: TimesheetEntry[];
  breakAttestations: BreakAttestation[];
  clockInTime: {
    clockIn: Date;
    clockInLocal: Date;
    clockOut: Date;
    clockOutLocal: Date;
    isInProgress: boolean;
  };
  isBefore?: boolean;
};

const AutomatedBreaksSummary = ({
  timesheetEntries,
  clockInTime,
  breakAttestations,
  isBefore = false,
}: Props) => {
  const summariesToDisplay = useAutomatedBreaksSummary({
    allTimesheetEntries: timesheetEntries,
    clockInTime,
    breakAttestations,
  });

  return (
    <>
      {summariesToDisplay.map(([firstSummary, secondSummary], index) => (
        <Row key={index}>
          <Text14
            themeColor={isBefore ? ThemeColorType.iconGray : firstSummary.themeColor}
            data-for={TOOLTIP_ID}
            data-tip={firstSummary.tipText}
            strikethrough={isBefore}>
            {firstSummary.text}
          </Text14>
          {secondSummary && (
            <Text14
              themeColor={isBefore ? ThemeColorType.iconGray : ThemeColorType.gray}
              strikethrough={isBefore}>
              &nbsp;·&nbsp;
            </Text14>
          )}
          {secondSummary && (
            <Text14
              themeColor={isBefore ? ThemeColorType.iconGray : secondSummary.themeColor}
              data-for={TOOLTIP_ID}
              data-tip={secondSummary.tipText}
              strikethrough={isBefore}>
              {secondSummary.text}
            </Text14>
          )}
        </Row>
      ))}

      <Tooltip id={TOOLTIP_ID} type="error" />
    </>
  );
};

export default AutomatedBreaksSummary;
